// My details (src/pages/MyDetails.jsx): what a crew login may change on its OWN record without Crew Edit - phone, e-mail,
// emergency contact (sql/test-fixes-5.sql crew_private own-row rule + crew_private_guard). Empty = cleared (null).
import { OWN_CONTACT_FIELDS } from './crewPrivacy.js'
export const CONTACT_LABELS = { phone: 'Phone', email: 'E-mail', emergency_contact_name: 'Emergency contact (name)', emergency_contact_phone: 'Emergency contact (phone)' }
export const contactPatch = form => Object.fromEntries(OWN_CONTACT_FIELDS.map(k => [k, String((form || {})[k] ?? '').trim() || null]))
export const contactError = form => {
  const e = String((form || {}).email ?? '').trim()
  return e && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) ? 'That e-mail address does not look right' : ''
}
